var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmarkCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "checkmark-circle",
    clipPath: "url(#clip0_2226_13369)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M35.5 3.12911C39.8712 3.12911 44.1102 3.98472 48.0995 5.67195C51.9538 7.30216 55.416 9.63664 58.3897 12.6103C61.3635 15.5842 63.6978 19.0462 65.3282 22.9007C67.0154 26.8898 67.8709 31.1288 67.8709 35.5C67.8709 39.8712 67.0154 44.1102 65.328 48.0995C63.6977 51.9538 61.3634 55.416 58.3895 58.3897C55.4158 61.3635 51.9536 63.6978 48.0993 65.3282C44.1102 67.0154 39.8712 67.8709 35.5 67.8709C31.1288 67.8709 26.8898 67.0154 22.9007 65.328C19.0462 63.6977 15.5842 61.3634 12.6103 58.3895C9.63664 55.4158 7.30216 51.9536 5.67195 48.0993C3.98472 44.1102 3.12911 39.8712 3.12911 35.5C3.12911 31.1288 3.98472 26.8898 5.67195 22.9007C7.30216 19.0462 9.63664 15.5842 12.6103 12.6103C15.5842 9.63664 19.0462 7.30216 22.9007 5.67195C26.8898 3.98472 31.1288 3.12911 35.5 3.12911ZM35.5 0.5C16.17 0.5 0.5 16.17 0.5 35.5C0.5 54.83 16.17 70.5 35.5 70.5C54.83 70.5 70.5 54.83 70.5 35.5C70.5 16.17 54.83 0.5 35.5 0.5Z",
    fill: "#207C7B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M28.1477 50.0814C28.3898 49.7775 28.4999 49.5822 28.654 49.4303C38.0883 40.1202 47.5335 30.8102 56.9788 21.5001C57.6503 20.8382 58.1236 20.7514 58.575 21.1854C59.0043 21.6086 58.8942 22.1403 58.2668 22.7588C48.5573 32.3402 38.8369 41.9106 29.1384 51.5028C28.4339 52.2081 27.8945 52.1973 27.2119 51.5137C22.3902 46.7393 17.5575 41.9866 12.7358 37.2339C12.6037 37.1037 12.4606 36.9843 12.3616 36.8433C12.0753 36.4526 12.1084 36.062 12.4276 35.7039C12.7358 35.3675 13.2532 35.3241 13.6275 35.6063C13.7706 35.7148 13.8917 35.8558 14.0238 35.9752C18.5813 40.4675 23.1278 44.9489 27.6743 49.4411C27.8284 49.5931 27.9385 49.7884 28.1477 50.0814Z",
    fill: "#207C7B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2226_13369"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkCircle);
export default __webpack_public_path__ + "static/media/checkmark-circle.cfc819e8.svg";
export { ForwardRef as ReactComponent };